import {SaveSaleVehicleFinancingBody} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {FinancingMoney} from '../types/FinancingMoney';
import {FinancingTemplateDraft} from '../types/FinancingTemplateDraft';

type KeysWithValue<TRecord, TValue> = {
  [TKey in keyof TRecord]-?: TRecord[TKey] extends TValue ? TKey : never;
}[keyof TRecord];

interface FinancingCostOverrideDescriptor {
  getLabel: () => string;
  includedOverrideKey: KeysWithValue<SaveSaleVehicleFinancingBody, boolean | null>;
  amountOverrideKey: KeysWithValue<SaveSaleVehicleFinancingBody, FinancingMoney>;
  templateIncludedKey: KeysWithValue<FinancingTemplateDraft, boolean>;
  templateAmountKey: KeysWithValue<FinancingTemplateDraft, FinancingMoney>;
}

/**
 * The German-tenant one-time costs a vehicle financing can override per field. The overrides
 * panel renders one control pair per entry, and the count/reset helpers walk the same list, so a
 * new cost is added in exactly one place.
 */
export const FINANCING_COST_OVERRIDES: FinancingCostOverrideDescriptor[] = [
  {
    getLabel: () => i18n.t('page.vehicle.financingAndLeasing.vehicleTransfer'),
    includedOverrideKey: 'vehicleTransferIncludedOverride',
    amountOverrideKey: 'vehicleTransferAmountOverride',
    templateIncludedKey: 'vehicleTransferIncluded',
    templateAmountKey: 'vehicleTransferAmount',
  },
  {
    getLabel: () => i18n.t('page.vehicle.financingAndLeasing.vehicleRegistration'),
    includedOverrideKey: 'vehicleRegistrationIncludedOverride',
    amountOverrideKey: 'vehicleRegistrationAmountOverride',
    templateIncludedKey: 'vehicleRegistrationIncluded',
    templateAmountKey: 'vehicleRegistrationAmount',
  },
  {
    getLabel: () => i18n.t('page.vehicle.financingAndLeasing.vehicleDelivery'),
    includedOverrideKey: 'vehicleDeliveryIncludedOverride',
    amountOverrideKey: 'vehicleDeliveryAmountOverride',
    templateIncludedKey: 'vehicleDeliveryIncluded',
    templateAmountKey: 'vehicleDeliveryAmount',
  },
];
